import React, { useRef, useState } from "react";
import { WipBanner } from "@/components/mock/MockKit";

// Embeds the real v20 bundle (public/v20mock.html) in a same-origin iframe and
// drives it to a single view, hiding the bundle's own app chrome (auth gate,
// sidebar, topbar). This gives exact v20 components, colors, mock data and every
// button interaction / modal by construction — wrapped in our React app shell.
export default function V20Embed({ view, testid, banner = true }) {
  const iframeRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const embedCss = `
    #authGate,.sidebar,.topbar,#__bundler_loading,#__bundler_thumbnail,#__bundler_placeholder,#__bundler_err{display:none!important;}
    .main{margin-left:0!important;width:100%!important;}
    .content{width:100%!important;max-width:100%!important;padding-top:14px!important;}
    html,body{overflow:auto!important;background:#f5f5f7!important;}
  `;

  const drive = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    let tries = 0;
    const tick = () => {
      tries += 1;
      let win, doc;
      try {
        win = iframe.contentWindow;
        doc = iframe.contentDocument || (win && win.document);
      } catch (e) {
        return;
      }
      if (doc && win && typeof win.showView === "function") {
        if (!doc.getElementById("revq-embed-css")) {
          const st = doc.createElement("style");
          st.id = "revq-embed-css";
          st.textContent = embedCss;
          doc.head.appendChild(st);
        }
        try {
          win.showView(view);
          if (view === "focus" && typeof win.renderFocus === "function") win.renderFocus();
        } catch (e) {}
        setLoading(false);
        return;
      }
      if (tries < 120) setTimeout(tick, 100);
    };
    tick();
  };

  return (
    <div className="flex flex-col h-full" data-testid={testid}>
      {banner ? (
        <div className="px-7 pt-5 pb-2">
          <WipBanner />
        </div>
      ) : null}
      <div className="relative flex-1 min-h-0">
        {loading ? (
          <div className="absolute inset-0 flex items-center justify-center bg-[#f5f5f7] z-10" data-testid={`${testid}-loading`}>
            <div className="revq-spinner" style={{ borderTopColor: "#000", borderColor: "rgba(0,0,0,.18)" }} />
          </div>
        ) : null}
        <iframe
          ref={iframeRef}
          src="/v20mock.html"
          title={testid}
          onLoad={drive}
          data-testid={`${testid}-frame`}
          className="w-full h-full block border-0"
        />
      </div>
    </div>
  );
}
